import React from 'react';
import { Calendar } from 'lucide-react';

const BookTrialButton = () => {
  const phoneNumber = '60166291687';
  const message = encodeURIComponent(
    "Hi Kalah, I'd like to book a FREE TRIAL CLASS at Read Right Academy. Please share the next available slot."
  );
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="sticky-book-trial-button"
      aria-label="Book a free trial class on WhatsApp"
      className="fixed z-50 bottom-6 left-4 sm:left-6 group inline-flex items-center gap-2 bg-[#3B4BA0] hover:bg-[#2d3a7a] text-white font-semibold px-4 py-3 sm:px-5 sm:py-3.5 rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105 border-2 border-white/20"
    >
      <span className="relative flex items-center justify-center w-7 h-7 bg-white/15 rounded-full">
        <Calendar className="h-4 w-4" />
        <span className="absolute inset-0 rounded-full bg-white/30 animate-ping opacity-40" />
      </span>
      <span className="text-sm sm:text-base whitespace-nowrap">
        Book Free Trial
      </span>
    </a>
  );
};

export default BookTrialButton;
